import { useNavigate } from 'react-router-dom'
import { trackInternalEvent } from '@rio/tracking'

import { ErrorLayout } from './ErrorLayout'
import MULTIPLE_ERRORS from './assets/no_work_experience.png'
import { NoWorkExperienceImage } from './styles'
import { ErrorComponentProps } from './types'

export const NoTargetLocationAndNoWorkExperience = ({ CustomContainer }: ErrorComponentProps) => {
  const navigate = useNavigate()

  return (
    <ErrorLayout
      CustomContainer={CustomContainer}
      Images={<NoWorkExperienceImage src={MULTIPLE_ERRORS} alt="no_location_no_work_experience" />}
      translationKey="no_target_location_no_work_experience"
      onClick={() => {
        trackInternalEvent('view_profile_editor', { label: 'recommended_jobs' })
        navigate(
          '/career-profile/edit?section=jobPreferences&returnUrl=/job-search?view=recommendation',
        )
      }}
    />
  )
}
